import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class EmailMessageService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "emailmessage");
    }
}
